import { styled, theme, utils } from 'ui/theme';

export const Styles = {
  Options: styled('div')`
    border-radius: 4px;
    grid-column: 1 / -1;
    overflow: hidden;
    row-gap: ${theme.space[1]};

    ${utils.media.min('l')`
      grid-column: 4 / span 9;
    `}
  `,

  Wrapper: styled('div')`
    ${utils.grid.size[12]};
    column-gap: ${theme.space[4]};
    row-gap: ${theme.space[1]};
    padding-bottom: ${theme.space[12]};
  `,
};

export const SkeletonStyles = {
  Button: styled('div')`
    width: 100%;
    height: ${theme.sizes[12]};
  `,

  Image: styled('div')`
    min-width: calc(${theme.sizes[11]} * 3);
    height: calc(${theme.sizes[6]} * 3);
  `,

  PriceInfo: styled('div')`
    align-items: center;
    background: ${theme.colors.build.lightDark1};
    border-radius: ${theme.radii.small};
    display: flex;
    justify-content: space-between;
    margin: ${theme.space[1]} ${theme.space[0]};
  `,

  QuantitySelector: styled('div')`
    width: 100%;
    height: ${theme.sizes[12]};
  `,

  Wrapper: styled('div')`
    display: flex;
    flex-direction: row;
    margin: ${theme.space[4]} ${theme.space[0]};
    overflow: hidden;
  `,
};
